import { render } from "./endLive.vue?vue&type=template&id=09324dd0"
import script from "./endLive.vue?vue&type=script&lang=js"
export * from "./endLive.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__